import { Component, Input, OnInit } from "@angular/core";
import { QuestionEntity } from "src/app/models/new-product/base/question-entity.model";
import { ProposalConst } from "src/app/models/new-product/sme/mortgage-fire/singapore/base/mf-sg-proposal-constant";

@Component({
    selector: "drop-down-list-filter-question",
    templateUrl: "./drop-down-list-filter-question.component.html",
    styleUrls: ["./drop-down-list-filter-question.component.scss"],
    standalone: false
})
export class DropDownListFilterQuestionComponent implements OnInit {
  @Input() public question!: QuestionEntity;
  @Input() public onValueChange?: (args: any) => void;
  noAnswerDefaultText = ProposalConst.noAnswerDefaultText;

  constructor() {}

  ngOnInit(): void {}

  answerDisplayText(question: QuestionEntity): string {
    let answerDisplayText: string = "";
    /*this.answer = "1";*/
    question.options.forEach((option) => {
      if (option.value === question.answer) {
        answerDisplayText = option.key;
      }
    });
    return answerDisplayText;
  }

  public valueChange(evt?: any) {
    if (this.onValueChange) {
      this.onValueChange(evt);
    }
  }
}
